module.exports = __webpack_public_path__ + "img/img-28.e54ef09a.png";